import { ChangeTypeGroup } from "../ChangeTypeGroup";
import { ChangeHistoryRow } from "../types";
import { useAssetResolvedChanges } from "../useAssetResolvedChanges";

export const AttributeCell = ({ row }: { row: ChangeHistoryRow }) => {
  const changes = useAssetResolvedChanges(row);

  return (
    <div>
      {changes.map((change) => (
        <ChangeTypeGroup
          key={change.id}
          action={change.action}
          fieldName={change.fieldName}
          fieldPath={change.fieldPath}
          oldValue={change.oldValue}
          newValue={change.newValue}
          arrayLength={change.arrayLength}
          details={change.details}
          oldSnapshotId={change.oldSnapshotId}
          newSnapshotId={change.newSnapshotId}
        />
      ))}
    </div>
  );
};
